import Archive from 'lucide-react/dist/esm/icons/archive.mjs'
import CalendarDays from 'lucide-react/dist/esm/icons/calendar-days.mjs'
import Home from 'lucide-react/dist/esm/icons/home.mjs'
import Layers3 from 'lucide-react/dist/esm/icons/layers-3.mjs'
import Link2 from 'lucide-react/dist/esm/icons/link-2.mjs'
import Package from 'lucide-react/dist/esm/icons/package.mjs'
import Settings from 'lucide-react/dist/esm/icons/settings.mjs'
import Smartphone from 'lucide-react/dist/esm/icons/smartphone.mjs'
import UsersRound from 'lucide-react/dist/esm/icons/users-round.mjs'

export const navigationItems = [
  { path: '/overview', label: '运营总览', icon: Home, permission: 'overview' },
  { path: '/schedule', label: '发布排期', icon: CalendarDays, collection: 'plans', permission: 'schedule' },
  { path: '/inventory', label: '作品库存', icon: Archive, collection: 'assets', permission: 'inventory' },
  { path: '/templates', label: '内容模板', icon: Layers3, permission: 'templates' },
  { path: '/references', label: '参考作品', icon: Link2, permission: 'references' },
  { path: '/matrix', label: '设备账号', icon: Smartphone, permission: 'matrix' },
  { path: '/products', label: '产品', icon: Package, permission: 'products' },
  { path: '/settings', label: '项目设置', icon: Settings, permission: 'settings' },
]

export const flatNavigation = navigationItems

export const platformNavigationItems = [
  { path: '/members', label: '成员与权限', icon: UsersRound, ownerOnly: true },
]
